import { render, staticRenderFns } from "./orgchart.vue?vue&type=template&id=1cc3e608&scoped=true"
import script from "./orgchart.vue?vue&type=script&lang=js"
export * from "./orgchart.vue?vue&type=script&lang=js"
import style0 from "./orgchart.vue?vue&type=style&index=0&id=1cc3e608&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc3e608",
  null
  
)

export default component.exports